import { Mail, Phone, MapPin } from "lucide-react";
import { LOGO_SECONDARY } from "@/lib/constants";

export const Footer = () => (
  <footer
    id="contact"
    data-testid="site-footer"
    className="border-t-2 border-black bg-black text-white"
  >
    <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-10 px-5 py-14 md:grid-cols-12 md:px-10 md:py-20">
      <div className="md:col-span-5">
        <div className="flex items-center gap-3">
          <img
            src={LOGO_SECONDARY}
            alt="Home Guard Developments"
            className="h-12 w-12 border-2 border-white bg-black object-contain p-1"
          />
          <div className="flex flex-col leading-none">
            <span className="font-display text-base font-black tracking-tight">
              HOME GUARD
            </span>
            <span className="font-display text-[11px] font-bold tracking-[0.25em] text-[#9D4CDD]">
              DEVELOPMENTS
            </span>
          </div>
        </div>
        <p className="mt-6 max-w-sm font-display text-base text-white/70">
          Trusted garden landscape transformations across Ayrshire, Scotland.
          Fixed-budget, fixed-quality.
        </p>
      </div>

      <div className="md:col-span-4">
        <div className="mb-4 font-display text-[10px] font-bold uppercase tracking-[0.25em] text-[#9D4CDD]">
          Get in touch
        </div>
        <ul className="space-y-3">
          <li className="flex items-start gap-3">
            <Mail className="mt-0.5 h-4 w-4 text-[#9D4CDD]" />
            <a
              href="mailto:info@homeguarddevelopments.co.uk"
              data-testid="footer-email"
              className="font-display text-sm text-white underline-offset-4 hover:underline"
            >
              info@homeguarddevelopments.co.uk
            </a>
          </li>
          <li className="flex items-start gap-3">
            <MapPin className="mt-0.5 h-4 w-4 text-[#9D4CDD]" />
            <span className="font-display text-sm text-white/80">
              Serving all of Ayrshire, Scotland
            </span>
          </li>
          <li className="flex items-start gap-3">
            <Phone className="mt-0.5 h-4 w-4 text-[#9D4CDD]" />
            <span className="font-display text-sm text-white/80">
              Mon–Sat · 8am to 6pm
            </span>
          </li>
        </ul>
      </div>

      <div className="md:col-span-3">
        <div className="mb-4 font-display text-[10px] font-bold uppercase tracking-[0.25em] text-[#9D4CDD]">
          The promise
        </div>
        <p className="font-display text-sm leading-relaxed text-white/70">
          Every garden makeover capped at <strong className="text-white">£2,000</strong>.
          No hidden fees. No upsells. Just better outdoor living.
        </p>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-3 px-5 py-5 md:flex-row md:items-center md:px-10">
        <p className="font-display text-[11px] font-bold uppercase tracking-[0.25em] text-white/50">
          © {new Date().getFullYear()} Home Guard Developments
        </p>
        <p className="font-display text-[11px] font-bold uppercase tracking-[0.25em] text-white/50">
          Are you summer ready? Give your garden a makeover.
        </p>
      </div>
    </div>
  </footer>
);
